import AmigoLogoSvg from 'assets/images/amigo-logo.svg'
import React from 'react'
import Konami from 'react-konami-code'
import styled from 'styled-components'

const AmigoLogo = styled.img.attrs<{}>(() => ({
  src: AmigoLogoSvg
}))`
  position: absolute;
  left: 50%;
  top: 0;
  width: 2rem;
`

// Our very own easter egg. Enter AMIGO in the UI and check out Greg's dog!
const AmigoEasterEgg = () => {
  const [showAmigo, setShowAmigo] = React.useState<boolean>(false)
  return (
    <>
      <Konami
        action={() => setShowAmigo(true)}
        code={[65, 77, 73, 71, 79]}
        onTimeout={() => setShowAmigo(false)}
        timeout={2000}
      />

      {showAmigo && <AmigoLogo />}
    </>
  )
}

export default AmigoEasterEgg
